export default "__VITE_ASSET__727c4c31__"